module.exports = __webpack_public_path__ + "331360b92fd3340aae75bd61555c3376.fbx";